export const exteriorView07ImageOptions = {
  angle: 'ExteriorView07',
  staticOptions: {
    HullColorways: 1,
    Bowsprit: 1,
    HullTreatment: 1,
    BathingLadder: 1,
    CockpitLockers: 1,
    RemovableCockpitTable: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    Mainsail: 1,
    Flag: 1
  },
  mattes: [
    {
      option: 'BathingLadder',
      dependency: null
    },
    {
      option: 'CockpitLockers',
      dependency: null
    },
    {
      option: 'RemovableCockpitTable',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: null
    }
  ],
  overlays: []
}



// WEBPACK FOOTER //
// ./src/Xr41/views/ExteriorView07.js